import 'react-app-polyfill/stable';
import React from 'react';
import App from './App';
import '@fontsource/roboto';
import './style.css';
import Axios from 'axios';

import { styled } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { theme } from 'lib/theme';
import { isMock } from 'lib/util';

import { createRoot } from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

if (isMock()) require('lib/MSWManager');

Axios.defaults.baseURL = process.env.REACT_APP_URL;
Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      document.location.href = '/';
    }
    return Promise.reject(error);
  }
);

const AppContainer = styled('div')({
  outline: `4px solid ${process.env.REACT_APP_ENV_COLOR}`,
  outlineOffset: '-4px',
  height: '100%',
  minHeight: '100vh'
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <React.StrictMode>
          <AppContainer>
            <App />
          </AppContainer>
        </React.StrictMode>
      </SnackbarProvider>
    </LocalizationProvider>
  </ThemeProvider>
);
